import React, { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Jumbotron } from 'reactstrap';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FaChevronLeft } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';

import './index.scss';

export const useCloudPassRedirectionHandler = ({
  failureRedirect,
  returnUrlRedirect,
  clientId,
  countryCode,
}) => {
  return useCallback((idp) => {
    const returnUrl = encodeURIComponent(returnUrlRedirect.replace(/\{IDP}/g, idp.shortName));

    window.location.assign(idp.loginURL
      .replace('{CP}', clientId)
      .replace(/\{IDP}/g, idp.shortName)
      .replace('{COUNTRY_CODE}', countryCode)
      .replace(/\{RETURN_URL}/g, returnUrl),
    )
  }, [failureRedirect, countryCode]);
};

const IdpSelectorAffiliates = ({
  history,
  contentProvider,
  loginURL,
  affiliatesURL,
  msoConfig,
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [state, setState] = useState({
    selectedCountryCode: searchParams.get('country'),
  })
  const countryClickHandler = (value) => setState(prev => ({
    ...prev,
    selectedCountryCode: value,
  }));

  // Todo: se harcodean los parametros path
  const projectId = 'motorplay_unified';

  const idpRedirectionHandler = useCloudPassRedirectionHandler({
    returnUrlRedirect: `${affiliatesURL}/processes/${projectId}/${contentProvider}/binding/accomplish?state=${new URLSearchParams(history.location.search).get('state')}&signature=${new URLSearchParams(history.location.search).get('signature')}&nva=${new URLSearchParams(history.location.search).get('nva')}&affiliate_idp={IDP}`,
    clientId: contentProvider,
    countryCode: searchParams.get('country'),
  })

  const selectedCountryMso = useMemo(() => Array.isArray(msoConfig) ? msoConfig.filter(e => e.countryCode === state.selectedCountryCode) : [], [msoConfig, state.selectedCountryCode]);

  const idps = useMemo(() => selectedCountryMso.length === 1 ? selectedCountryMso[0].idp : [], [selectedCountryMso]);
  const idpsInFooter = idps.filter(idp => idp.showInFooter);

  return (
    <React.Fragment>
      <div className="landingPage">
        <FormControl className={'select-country'}>
          <div className="idp-containerTitle mt-5">
            <FormattedMessage id="Idp.Selector.LandingPageContainerTitle" />
          </div>
          {state.selectedCountryCode && <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            className="select-countrySelect"
            defaultValue={state.selectedCountryCode}
            onChange={(v) => countryClickHandler(v.target.value)}
          >
            {msoConfig.length > 0 ? msoConfig.map(c => {
              return (
                <MenuItem
                  key={c.countryCode}
                  value={c.countryCode}
                  style={state.selectedCountryCode === c.countryCode ? { fontSize: '20px', color: '#79d6df' } : { fontSize: '16px' }}
                >
                  <img alt={c.countryCode} className="select-countryFlag" src={`https://sp.tbxnet.com/flags/default/${c.countryCode.toLowerCase()}.gif`} />
                  &nbsp;&nbsp;
                  <label className="countryLabel">{c.country}</label>
                </MenuItem>
              )
            }) : null}
          </Select>}
          <div className="idps">
            {idps.map(idp => (
              !idp.showInFooter &&
              <LoginLinkCP
                {...idp}
                key={idp.shortName}
                setState={setState}
                length={idps.length}
                onIdpSelected={() => {
                  idpRedirectionHandler({
                    ...idp,
                    loginURL,
                  });
                }}
              />
            ))}
          </div>
        </FormControl>
      </div>
      {
        !!idpsInFooter?.length &&
        <div className="footerIdps">
          {idpsInFooter.map((idp, i) => {
            return (
              <>
                <LoginLinkInFooter
                  {...idp}
                  key={idp.shortName}
                  onIdpSelected={() => {
                    idpRedirectionHandler({
                      ...idp,
                      loginURL,
                    });
                  }}
                />
                {i !== (idpsInFooter?.length - 1) && <label style={{ marginLeft: '20px', marginRight: '20px' }}>|</label>}
              </>
            );
          })
          }
        </div>
      }
    </React.Fragment>
  );
};

IdpSelectorAffiliates.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    goBack: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  }),
  msoConfig: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  contentProvider: PropTypes.string.isRequired,
  loginURL: PropTypes.string.isRequired,
  affiliatesURL: PropTypes.string.isRequired,
}

const LoginLinkCP = ({
  logo = '',
  description = '',
  onIdpSelected = () => null,
}) => (
  <div className="idp-item">
    <Jumbotron
      className="text-center" style={{ cursor: 'pointer' }}
      onClick={onIdpSelected}
    >
      <img
        alt="img-responsive"
        className="img-responsive"
        src={logo}
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          maxHeight: 55,
        }}
      />
      <p
        className={cx({
          'idp-description': description?.length > 20,
          'idp-description-medium': (description?.length >= 18 && description?.length <= 20),
        })}
      >{description}
      </p>
    </Jumbotron>
  </div>
);

LoginLinkCP.propTypes = {
  description: PropTypes.string,
  logo: PropTypes.string,
  onIdpSelected: PropTypes.func,
}

function LoginLinkInFooter(props) {
  return (
    <button
      onClick={props.onIdpSelected}
      className="idp"
    >
      <FormattedMessage id={props.description} />
    </button >);
};

export default IdpSelectorAffiliates
